import { render, staticRenderFns } from "./HSIndRegList.vue?vue&type=template&id=3b912e6e"
import script from "./HSIndRegList.vue?vue&type=script&lang=js"
export * from "./HSIndRegList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports